import { memo } from 'react';

import { useWorkspaceAgentGuidedVariantFlowStore } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/PrivateWorkspaceAgentGuidedVariantProvider';
import { PrivateWorkspaceAgentVariantNextActionsBody } from '~/components/v2/components/workspace/workspace-agent-panel/components/messages/PrivateWorkspaceAgentVariantNextActionsBody';

export type PrivateWorkspaceAgentVariantNextActionsProps = {
  show: boolean;
};

export const PrivateWorkspaceAgentVariantNextActions = memo(
  ({ show }: PrivateWorkspaceAgentVariantNextActionsProps) => {
    const isGuidedVariantFlowOpen = useWorkspaceAgentGuidedVariantFlowStore((state) => state.isGuidedVariantFlowOpen);

    if (!show || isGuidedVariantFlowOpen) {
      return null;
    }

    return (
      <div className="px-4 pb-3">
        <PrivateWorkspaceAgentVariantNextActionsBody />
      </div>
    );
  },
);

PrivateWorkspaceAgentVariantNextActions.displayName = 'PrivateWorkspaceAgentVariantNextActions';
